/*
 * @Author: liuwenjian
 * @Date: 2025-09-10 14:15:39
 * @LastEditors: liuwenjian
 * @LastEditTime: 2025-10-13 10:08:23
 */
//    ┏┓   ┏┓
//  ┏┛┻━━┛┻┓
//  ┃          ┃
//  ┃   ━     ┃
//  ┃ ┳┛ ┗┳ ┃
//  ┃          ┃
//  ┃   ┻     ┃
//  ┃          ┃
//  ┗━┓   ┏━┛
//     ┃   ┃
//     ┃   ┃
//     ┃   ┗━━━┓
//     ┃         ┣┓
//     ┃          ┏┛
//     ┗┓┓┏━┳┓┏┛
//       ┃┫┫ ┃┫┫
//       ┗┻┛ ┗┻┛
// Codes are far away from bugs with the animal protecting
// 神兽保佑,代码无bug

import Vue from 'vue'
import Router from 'vue-router'
import { constantRoutes } from './routes'
import baiduHmtBeforeHandler from './beforeEach/baidu_hmt'
import authorityBeforeHandler from './beforeEach/authority'
import UBT from '@/xreports/utils/matomoUbt'
import store from '@/xreports/store'

Vue.use(Router)

// 覆盖原型方法
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const createRouter = () =>
  new Router({
    mode: 'history',
    base: '/xreports',
    scrollBehavior: () => ({ y: 0 }),
    routes: [...constantRoutes],
  })

const router = createRouter()

router.beforeEach((to, from, next) => {
  // if (to.query.hideNav === '1' && ['QUALITY-INSPECTION-INDEX', 'DASHBOARD-INDEX'].includes(to.name)) {
  if (to.query.hideNav === '1') {
    store.commit('common/setHideChildMenu', true)
  }
  // 如果移动端菜单开启着 关闭一下
  document.querySelector('.voc-header-menu__drawer .el-icon-close') &&
    document.querySelector('.voc-header-menu__drawer .el-icon-close').click()
  // 触发埋点上报
  UBT.sendEvent()
  next()
})

const beforeHandlerList = [baiduHmtBeforeHandler, authorityBeforeHandler]
beforeHandlerList.forEach(beforeHandler => {
  beforeHandler(router)
})

export default router
